//CropPredictionPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import imageMap from '../assets/imageMap';

const CropRecommendationForm = () => {
  const [formData, setFormData] = useState({
    ph: '', nitrogen: '', phosphorus: '', potassium: '',
    temperature: '', humidity: '', windspeed: ''
  });

  const [city, setCity] = useState("");
  const [recommendations, setRecommendations] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // ✅ For popup

  useEffect(() => {
    if (city.length > 2) {
      axios.get(`http://localhost:5001/api/weather?city=${city}`)
        .then(res => {
          setFormData(prev => ({
            ...prev,
            temperature: res.data.temperature.toString(),
            humidity: res.data.humidity.toString(),
            windspeed: res.data.windspeed.toString()
          }));
        })
        .catch(err => console.error("Weather API Error:", err));
    }
  }, [city]);

  useEffect(() => {
    setRecommendations([]);
  }, [formData]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const tamilNaduDistricts = [
    "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul",
    "Erode", "Kallakurichi", "Kanchipuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai",
    "Nagapattinam", "Namakkal", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet",
    "Salem", "Sivaganga", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli",
    "Tirunelveli", "Tirupattur", "Tiruppur", "Vellore", "Viluppuram", "Virudhunagar"
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setRecommendations([]);

    try {
      const res = await axios.post("http://localhost:5001/recommend", formData);
      setRecommendations(res.data.recommendedCrops);
      setShowModal(true); // ✅ Show popup
    } catch (err) {
      console.error("🚨 Error Submitting Form:", err);
      setError("Failed to fetch recommendations. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <div style={{ width: '250px', backgroundColor: '#2e7d32', color: 'white', padding: '30px 20px' }}>
        <h2 style={{ textAlign: 'center' }}>Smart Farming</h2>
        <nav style={{ display: 'flex', flexDirection: 'column', gap: '35px', paddingLeft:'30px' }}>
          {["HOME", "CROP", "FERTILIZER", "WEATHER", "LEAF COLOR CHART"].map((item) => {
            const path = item === "LEAF COLOR CHART" ? "/lcc" : `/${item.toLowerCase()}`;
            return (
              <Link key={item} to={path} style={{ color: "white", textDecoration: "none" }}>
                {item}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, backgroundColor: '#f8f9fa', height: '100vh', overflowY: 'auto',
        boxSizing: 'border-box', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh' }}>
        <h2 style={{ backgroundColor: '#2e7d32', color: 'white', margin: 0, padding: '15px', width: '100%', textAlign: 'center' }}>
          CROP RECOMMENDATION
        </h2>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ backgroundColor: 'white', marginTop:'35px', padding: '20px', borderRadius: '10px', width: '80%', maxWidth: '600px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ backgroundColor: "white", padding: "15px", borderRadius: "10px", width: "80%", maxWidth: "600px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", marginBottom: "15px" }}>
            <div style={{ marginBottom: "10px" }}>
              <label style={{ fontWeight: "bold" }}>Select District (Tamil Nadu):</label>
              <select
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
                style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc", marginTop: "5px" }}
              >
                <option value="">Select District</option>
                {tamilNaduDistricts.map((district) => (
                  <option key={district} value={district}>{district}</option>
                ))}
              </select>
            </div>
          </div>

          {["ph", "nitrogen", "phosphorus", "potassium"].map((field) => (
            <div key={field} style={{ marginBottom: "10px" }}>
              <label style={{ fontWeight: "bold" }}>{field.toUpperCase()}:</label>
              <input type="number" name={field} value={formData[field]} onChange={handleChange} required style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }} />
            </div>
          ))}

          {["temperature", "humidity", "windspeed"].map((field) => (
            <div key={field} style={{ marginBottom: "10px" }}>
              <label style={{ fontWeight: "bold" }}>{field.toUpperCase()}:</label>
              <input type="number" name={field} value={formData[field]} readOnly style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc", backgroundColor: "#f0f0f0" }} />
            </div>
          ))}

          <button type="submit" style={{ width: '100%', padding: '10px', backgroundColor: '#2e7d32', color: 'white', borderRadius: '5px', border: 'none' }}>
            {loading ? "Fetching..." : "Submit"}
          </button>
        </form>

        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}

        {/* ✅ Modal Popup */}
        {showModal && (
  <div style={{
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999
  }}>
    <div style={{
      background: "white",
      padding: "30px 20px",
      borderRadius: "10px",
      maxWidth: "800px",
      width: "90%",
      maxHeight: "80vh", // ✅ Limit height
      overflowY: "auto",  // ✅ Enable scroll inside modal
      textAlign: "center",
      position: "relative",
    }}>
      <button onClick={() => setShowModal(false)} style={{
        position: "absolute",
        top: "10px",
        right: "15px",
        fontSize: "18px",
        background: "none",
        border: "none",
        cursor: "pointer"
      }}>✖</button>

      <h3>Recommended Crops:</h3>
      {recommendations.length === 0 ? (
        <p>No suitable crops found.</p>
      ) : (
        <ul style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
          listStyle: "none",
          padding: 0,
          marginTop: "20px",
        }}>
          {recommendations.map((crop, index) => (
            <li key={index} style={{
              width: "180px",
              textAlign: "center",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "15px",
              background: "#f9f9f9"
            }}>
              <h4 style={{ fontSize: "16px", marginBottom: "10px" }}>{crop.crop}</h4>
              <img src={imageMap[crop.image]} alt={crop.crop} width="150" style={{ borderRadius: "6px", objectFit: "cover" }} />
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
)}

      </div>
    </div>
  );
};

export default CropRecommendationForm;
